import {Component, Input} from '@angular/core';

@Component({
	selector: 'conversation-placeholder',
	template: `
    <div class="ph-item" *ngFor="let index of rows | ngForTimes">
      <div class="ph-col-2">
        <div class="ph-avatar"></div>
      </div>
      <div>
        <div class="ph-row">
          <div class="ph-col-12 big"></div>
          <div class="ph-col-10"></div>
        </div>
      </div>
    </div>
	`,
})
export class ConversationPlaceholderComponent {
	@Input()public  rows: number = 3;
}
